// // // import React from "react";
// // // import "bootstrap/dist/css/bootstrap.min.css";
// // // import "bootstrap-icons/font/bootstrap-icons.css";
// // // import "./Header.css";
// // // import Logo from "../assets/logo-dark2.png";
// // // // black background version
// // // import myVideo from "../assets/BrandVideo.mp4";
// // import React from "react";
// // import "bootstrap/dist/css/bootstrap.min.css";
// // import "bootstrap-icons/font/bootstrap-icons.css";
// // import "bootstrap/dist/js/bootstrap.bundle.min.js"; // ✅ Add this
// // import "./Header.css";
// // import Logo from "../assets/logo-dark2.png";
// // import myVideo from "../assets/BrandVideo.mp4";

// // const Header = () => {
// //   return (
// //     <>
// //       <nav className="navbar navbar-expand-lg fixed-top glass-navbar-dark py-2">
// //         <div className="container">
// //           <a className="navbar-brand d-flex align-items-center" href="#">
// //             <img
// //               src={Logo}
// //               alt="Logo"
// //               style={{ height: "60px", width: "auto" }}
// //               className="me-3"
// //             />
// //             <div>
// //               <h5 className="mb-0 fw-bold text-white">UV MEDIA</h5>
// //               {/* <small className="text-teal fst-italic">
// //                 From lens to screen.
// //               </small> */}
// //             </div>
// //           </a>
// //           <button
// //             className="navbar-toggler"
// //             type="button"
// //             data-bs-toggle="collapse"
// //             data-bs-target="#navbarNav"
// //             aria-controls="navbarNav"
// //             aria-expanded="false"
// //             aria-label="Toggle navigation"
// //           >
// //             <span className="navbar-toggler-icon" />
// //           </button>
// //           <div className="collapse navbar-collapse" id="navbarNav">
// //             <ul className="navbar-nav ms-auto align-items-center gap-3">
// //               {["Home", "About Us", "Services", "Clients", "Contact Us"].map(
// //                 (item, idx) => (
// //                   <li className="nav-item" key={idx}>
// //                     <a className="nav-link text-white" href="#">
// //                       {item}
// //                     </a>
// //                   </li>
// //                 )
// //               )}
// //               <li>
// //                 <button className="btn btn-glow rounded-pill px-3">
// //                   Request a Callback
// //                 </button>
// //               </li>
// //               {/* <li>
// //                 <i className="bi bi-search text-white fs-5 ms-3"></i>
// //               </li> */}
// //             </ul>
// //           </div>
// //         </div>
// //       </nav>

// //       {/* Hero Section */}
// //       {/* <header className="hero-section position-relative text-center">
// //         <video autoPlay muted loop playsInline className="hero-video">
// //           <source src={myVideo} type="video/mp4" />
// //           Your browser does not support the video tag.
// //         </video> */}

// //       {/* </header> */}
// //     </>
// //   );
// // };

// // export default Header;

// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "./Header.css";
// import Logo from "../assets/logo-dark2.png";

// const Header = () => {
//   return (
//     <>
//       <nav className="navbar navbar-expand-lg fixed-top glass-navbar-dark py-2">
//         <div className="container">
//           {/* Logo → Home */}
//           <a className="navbar-brand d-flex align-items-center" href="#home">
//             <img
//               src={Logo}
//               alt="Logo"
//               style={{ height: "60px", width: "auto" }}
//               className="me-3"
//             />
//             <div>
//               <h5 className="mb-0 fw-bold text-white">UV MEDIA</h5>
//             </div>
//           </a>

//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNav"
//             aria-controls="navbarNav"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon" />
//           </button>

//           <div className="collapse navbar-collapse" id="navbarNav">
//             <ul className="navbar-nav ms-auto align-items-center gap-3">
//               <li className="nav-item">
//                 <a className="nav-link text-white" href="#home">
//                   Home
//                 </a>
//               </li>

//               <li className="nav-item">
//                 <a className="nav-link text-white" href="#about">
//                   About Us
//                 </a>
//               </li>

//               <li className="nav-item">
//                 <a className="nav-link text-white" href="#services">
//                   Services
//                 </a>
//               </li>

//               <li className="nav-item">
//                 <a className="nav-link text-white" href="#clients">
//                   Clients
//                 </a>
//               </li>

//               <li className="nav-item">
//                 <a className="nav-link text-white" href="#contact">
//                   Contact Us
//                 </a>
//               </li>

//               <li>
//                 <a
//                   href="https://forms.gle/BH63MFpPcvg25gRa6"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="btn btn-glow rounded-pill px-3"
//                 >
//                   Request a Callback
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// };

// export default Header;


// import React from "react";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "./Header.css";
// import Logo from "../assets/logo-dark2.png";

// const Header = () => {
//   return (
//     <>
//       <nav className="navbar navbar-expand-lg fixed-top glass-navbar-dark py-2">
//         <div className="container">
//           {/* Logo → Home */}
//           <Link className="navbar-brand d-flex align-items-center" to="/#home">
//             <img
//               src={Logo}
//               alt="UV Media Logo"
//               style={{ height: "60px", width: "auto" }}
//               className="me-3"
//             />
//             <div>
//               <h5 className="mb-0 fw-bold text-white">UV MEDIA</h5>
//             </div>
//           </Link>

//           {/* Mobile Toggle */}
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNav"
//             aria-controls="navbarNav"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon" />
//           </button>

//           {/* Navbar Links */}
//           <div className="collapse navbar-collapse" id="navbarNav">
//             <ul className="navbar-nav ms-auto align-items-center gap-3">
//               <li className="nav-item">
//                 <Link className="nav-link text-white" to="/#home">
//                   Home
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link text-white" to="/#about">
//                   About Us
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link text-white" to="/#services">
//                   Services
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link text-white" to="/#clients">
//                   Clients
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link text-white" to="/#contact">
//                   Contact Us
//                 </Link>
//               </li>

//               {/* CTA Button */}
//               <li>
//                 <a
//                   href="https://forms.gle/BH63MFpPcvg25gRa6"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="btn btn-glow rounded-pill px-3"
//                 >
//                   Request a Callback
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// };

// export default Header;


import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Header.css";
import Logo from "../assets/logo-dark2.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg fixed-top glass-navbar-dark py-2">
        <div className="container">
          {/* Logo */}
          <a className="navbar-brand d-flex align-items-center" href="/#home" onClick={closeMenu}>
            <img
              src={Logo}
              alt="Logo"
              style={{ height: "60px", width: "auto" }}
              className="me-3"
            />
            <h5 className="mb-0 fw-bold text-white">UV MEDIA</h5>
          </a>

          {/* Hamburger */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-expanded={isOpen}
          >
            <span className="navbar-toggler-icon" />
          </button>

          {/* Menu */}
          <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
            <ul className="navbar-nav ms-auto align-items-center gap-3">
              <li className="nav-item">
                <a className="nav-link" href="/#home" onClick={closeMenu}>
                  Home
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="/#about" onClick={closeMenu}>
                  About Us
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="/#services" onClick={closeMenu}>
                  Services
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="/#clients" onClick={closeMenu}>
                  Clients
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="/#contact" onClick={closeMenu}>
                  Contact Us
                </a>
              </li>

              <li>
                <a
                  href="https://forms.gle/BH63MFpPcvg25gRa6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-glow rounded-pill px-3"
                  onClick={closeMenu}
                >
                  Request a Callback
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
